<template>
  <div>
    <!-- billing: {{billing_id}} -->
    <v-expansion-panel v-if="communicationList && communicationList.length > 0">
      <v-expansion-panel-content
        v-for="(item, i) in communicationList"
        :key="i"
      >
        <template v-slot:header>
          <!-- <div class="font-weight-bold">{{item.name | formatCommunicationType}}</div> -->
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon class="grey--text">{{
                item.medium | formatCommunicationMedium
              }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <!-- <v-list-tile-sub-title>Faturado em</v-list-tile-sub-title> -->
              <v-list-tile-title>
                <div>{{ item.name | formatCommunicationType }}</div>
              </v-list-tile-title>
              <v-list-tile-sub-title>{{ item.medium }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-card class="pl-1 pr-1">
          <!-- <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text> -->
          <v-data-table
            :headers="headers"
            :items="item.history"
            class="elevation-0"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{ props.item.at | formatarDateTime }}</td>
              <td class="text-xs-right">
                {{ props.item.event | formatStatusCommunicationEvent }}
              </td>
              <!-- <td class="text-xs-right">{{ props.item.fat }}</td>
                    <td class="text-xs-right">{{ props.item.carbs }}</td>
                    <td class="text-xs-right">{{ props.item.protein }}</td>
                    <td class="text-xs-right">{{ props.item.iron }}</td> -->
            </template>
          </v-data-table>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <div v-else class="pl-5 pr-3 align-center">Não há comunicados enviados</div>
  </div>
</template>
<script>
// import { eventBus } from '../../main';
import { getBillingCommunications } from "../../services/communication";
export default {
  props: ["billing_id"],
  data() {
    return {
      //  data: () => ({
      currentUser: {},
      // billing_id: null,
      communicationList: [],
      headers: [
        { text: "Data", value: "at" },
        { text: "Ação", value: "event" },
      ],
    };
  },
  //  }),
  created() {
    // console.log('billing_id: ', this.billing_id)
    if (this.billing_id) {
      this.communicationList = [];
      getBillingCommunications(this.billing_id)
        .then(async (communications) => {
          for (let i = 0; i < communications.size; i++) {
            let communication = {
              id: communications.docs[i].id,
              // name: communications.docs[i].data().name,
              // history: communications.docs[i].data().history
              ...communications.docs[i].data(),
            };
            this.communicationList.push(communication);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  watch: {
    billing_id() {
      this.communicationList = [];
      getBillingCommunications(this.billing_id)
        .then(async (communications) => {
          for (let i = 0; i < communications.size; i++) {
            let communication = {
              id: communications.docs[i].id,
              ...communications.docs[i].data(),
            };
            this.communicationList.push(communication);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  filters: {
    formatCommunicationType: function (value) {
      if (!value) return "";
      switch (value) {
        case "lembrete":
          return "Aviso de Vencimento";
        case "notificacao_atraso":
          return "Notificação de Atraso";
        case "boleto_com_custodisp":
          return "Demonstrativo";
        case "boleto_sem_custodisp":
          return "Demonstrativo";
        case "cartao_com_custodisp":
          return "Demonstrativo";
        case "cartao_recusado":
          return "Demonstrativo Cartão Recusado";
        case "cartao_sem_custodisp":
          return "Demonstrativo";
        case "billing_deal":
          return "Campanha Cobrança";
        default:
          return value;
      }
    },
    formatCommunicationMedium: function (value) {
      if (!value) return "";
      switch (value) {
        case "sms":
          return "textsms";
        case "email":
          return "email";
        case "push":
          return "ad_units";
        // case 'url_clicked': return 'Click'
        default:
          return value;
      }
    },
    formatStatusCommunicationEvent: function (value) {
      if (!value) return "";
      switch (value) {
        case "request":
          return "Programado";
        case "accepted":
          return "Aceito";
        case "sent":
          return "Enviado";
        case "url_clicked":
          return "Click";
        case "opened":
          return "Aberto";
        case "processed":
          return "Processado pelo Sendgrid";
        case "drop":
          return "Drop";
        case "deferred":
          return "Envio adiado";
        case "block":
          return "Não enviado (block)";
        case "bounce":
          return "Não enviado (bounce)";
        case "delivered":
          return "Entregue";
        case "open":
          return "Aberto";
        case "click":
          return "Click";
        case "unsubscribe":
          return "Desinscrição";
        case "spamreport":
          return "Reportado como Spam";
        default:
          return value;
      }
    },
  },
};
</script>
